import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./DashboardSection.css";
import withTooltip from "components/library/Tooltip/withTooltip";
import { SECTIONS } from "config/constants";

const Text = ({ text, className }) => <span className={className}>{text}</span>;
const TextWithTooltip = withTooltip(Text);

class DashboardSection extends React.Component {
  formatSections() {
    let text, tooltip;

    let topicNames = Object.values(this.props.topics).map(x => x.name);
    let sectionIds = Object.values(this.props.sections).map(x => x.id);
    const isInTop =
      sectionIds.includes(SECTIONS.TOP.id) ||
      (this.props.primarySection &&
        this.props.primarySection.id === SECTIONS.TOP.id);
    const topicsCount = topicNames.length;

    if (!topicsCount && !isInTop) {
      text = "No section";
    } else if (!topicsCount && isInTop) {
      text = "Top";
    } else if (topicsCount == 1 && !isInTop) {
      text = topicNames[0];
    } else if (topicsCount == 1 && isInTop) {
      text = `Top, ${topicNames[0]}`;
    } else {
      if (!isInTop) {
        text = `${topicNames[0]} + ${topicsCount - 1}`;
      } else {
        text = `Top, ${topicNames[0]} + ${topicsCount - 1}`;
      }

      tooltip = topicNames.splice(1).map((name, i) => {
        return <div key={`name-${i}`}>{name}</div>;
      });
    }

    return { text, tooltip, topicNames, topicsCount, isInTop };
  }

  render() {
    const formattedSections = this.formatSections();
    const noSection =
      !formattedSections.topicsCount && !formattedSections.isInTop;
    return (
      <div className={styles.root}>
        {this.props.is_featured && (
          <div className={styles.featured}>Featured</div>
        )}
        <TextWithTooltip
          className={classNames({ [styles.noSection]: noSection })}
          text={formattedSections.text}
          tooltip={formattedSections.tooltip}
          isTooltipLeftAligned={true}
        />
      </div>
    );
  }
}

DashboardSection.propTypes = {
  topics: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      featured: PropTypes.bool,
      show_in_eden: PropTypes.bool,
    })
  ),
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
    })
  ),
  is_featured: PropTypes.bool,
  primarySection: PropTypes.object,
};

DashboardSection.defaultProps = {
  topics: [],
  sections: [],
};

export default DashboardSection;
